import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Col, FormGroup, Row } from 'reactstrap'
import useUpdateWallet from '../hooks/useUpdateWallet'
import useEditUserWallet from '../hooks/useEditUserWallet'

const EditWalletForm = ({isEditMode,walletData,onClose}) => {

    // hook for updating wallet
    const{isUpdating,isUpdated,updateUserWallet}=useUpdateWallet();
    const{isEditing,isEdited,editUserWallet} = useEditUserWallet();

    const{register,handleSubmit,formState:{errors,isSubmitting},reset} = useForm({
        defaultValues:{
            freeCredit:'',
            debtCredit:'',
            debtOwned:''
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    // when editing, populate the exisitng data
    useEffect(()=>{
        if(isEditMode && walletData){
            const formValues = {
                freeCredit: Number(walletData.free_credit),
                debtCredit: Number(walletData.debt_credit),
                debtOwned: Number(walletData.debt_owned)
            }

            reset(formValues)
        }else{
            reset();
        }
    },[isEditMode,walletData,reset])

    const onSubmit=async(data)=>{
        const payload = {
            free_credit : data.freeCredit,
            debt_credit: data.debtCredit,

            ...(isEditMode && {debt_owned: data.debtOwned}),
            
            ...({id:walletData.id})
        }

        if (isEditMode){
            editUserWallet(payload,{
                onSuccess:()=>{
                    onClose();
                }
            })
        }else{
            updateUserWallet(payload,{
                onSuccess:()=>{
                    onClose();
                }
            })
        }
        
    }
    
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
            <div className='d-flex justify-content-between align-items-center'>
                <div>
                    <FormGroup>
                        <label htmlFor='freeCredit' className='form-label'>Free Credits</label>
                        <input
                            type='number'
                            min={0}
                            step={1}
                            id='freeCredit'
                            name='freeCredit'
                            placeholder='Enter credits'
                            autoFocus
                            className='form-control border-primary-subtle'
                            {...register('freeCredit')}
                        />
                        {errors.freeCredit && (<div className="invalid-feedback d-block">{errors.freeCredit.message}</div>)}
                    </FormGroup>
                </div>
                <div>
                    <FormGroup>
                        <label htmlFor='debtCredit' className='form-label'>Loaned Credits</label>
                        <input
                            type='number'
                            min={0}
                            step={1}
                            id='debtCredit'
                            name='debtCredit'
                            placeholder='Enter credits'
                            autoFocus
                            className='form-control border-primary-subtle'
                            {...register('debtCredit')}
                        />
                        {errors.debtCredit && (<div className="invalid-feedback d-block">{errors.debtCredit.message}</div>)}
                    </FormGroup>
                </div>
                {isEditMode && <div>
                    <FormGroup>
                        <label htmlFor='debtOwned' className='form-label'>Credit Line</label>
                        <input
                            type='number'
                            min={0}
                            step={1}
                            id='debtOwned'
                            name='debtOwned'
                            placeholder='Enter credits'
                            autoFocus
                            className='form-control border-primary-subtle'
                            {...register('debtOwned')}
                        />
                        {errors.debtCredit && (<div className="invalid-feedback d-block">{errors.debtCredit.message}</div>)}
                    </FormGroup>
                </div>}
                <div className='pt-2'>
                    <Button 
                    type='submit'
                    style={{
                        backgroundColor: "#00ADF0",
                        color: "white",
                        fontWeight: "600",
                        border: "none"
                    }}
                    disabled={isUpdating || isSubmitting || isEditing}
                    >
                        {isEditMode ? "Update" : "Add Credits"}
                    </Button>
                </div>
            </div>
        </Row>
    </form>
  )
}

export default EditWalletForm
